import {
  Body,
  Font,
  Head,
  Html,
  Preview,
  Tailwind
} from '@react-email/components'
import React from 'react'

interface EmailProps {
  preview: string
  title: string
  children: React.ComponentProps<typeof Body>['children']
}

export function Email(props: EmailProps) {
  const { preview, title, children } = props

  return (
    <Tailwind>
      <Html>
        <Head>
          <title>{title}</title>
          <Font
            fontFamily='Inter'
            fallbackFontFamily='sans-serif'
            webFont={{
              url: 'https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap',
              format: 'woff2'
            }}
            fontWeight={400}
            fontStyle='normal'
          />
          <Preview>{preview}</Preview>
        </Head>
        <Body>{children}</Body>
      </Html>
    </Tailwind>
  )
}
